document.addEventListener('DOMContentLoaded', () => {
  const searchSelect = document.getElementById('header-search-select');
  if (searchSelect) {
    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get('type');
    if (typeParam) {
      searchSelect.value = typeParam;
    }
  }

  // header nav SP
  let focusEl = undefined;
  const nav = document.querySelector('.header-panel');
  if ( !nav ) {
    return;
  }

  document.querySelector(".js-open-nav") // open
  .addEventListener('click', (e) => {
    focusEl = e.currentTarget
    nav.setAttribute("aria-hidden", false);
    document.body.style.overflow = 'hidden';
  });
  document.querySelector('.js-close-nav') // close
  .addEventListener('click', () => {
    nav.setAttribute('aria-hidden', true);
    document.body.style.overflow = '';
    if ( focusEl ) {
      focusEl.focus();
    }
  });
});
